export const PixelBreakpointConstants = {
    SMALL: 576,
    MEDIUM: 768,
    LARGE: 992,
    XLARGE: 1200,
    XXLARGE: 1400,
};
